module.exports = __webpack_public_path__ + "static/media/notesSelected.dfd18f77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/notesSelected.jpg
// module id = 106
// module chunks = 0